
import { Component, Prop, Vue } from 'vue-property-decorator';
import { IAnswerHypermediaRepresentation } from '../../shared/contracts/AnswerContract';
import PointIndicator from '../shared/PointIndicator.vue';

@Component({
    components: {
        PointIndicator
    }
})
export default class Answer extends Vue {
    @Prop() answer: IAnswerHypermediaRepresentation;
}
